module.exports = __webpack_public_path__ + "img/gloves-no.f526bb53.svg";